export default "__VITE_ASSET__e6E23ogr__"